/**
 * MiniCartUpsellCarousel — standalone BlazeSlider carousel for the mini-cart.
 * Self-contained: does not extend BlazeProductCarousel.
 */
customElements.define(
  'mini-cart-upsell-carousel',
  class MiniCartUpsellCarousel extends HTMLElement {
    constructor() {
      super();
      this.blazeSlider = null;
      this._classObserver = null;
    }

    connectedCallback() {
      this.initSlider();
    }

    disconnectedCallback() {
      if (this.blazeSlider) {
        this.blazeSlider.destroy();
        this.blazeSlider = null;
      }
      if (this._classObserver) {
        this._classObserver.disconnect();
        this._classObserver = null;
      }
    }

    initSlider() {
      var sliderElement = this.querySelector('.blaze-slider');
      if (!sliderElement) return;

      var slides = sliderElement.querySelectorAll('.blaze-slide');
      if (slides.length <= 1) return;

      if (typeof window.BlazeSlider === 'undefined') {
        var script = document.querySelector('script[src*="blaze-slider"]');
        if (script) {
          script.addEventListener('load', () => this.initSlider(), { once: true });
        }
        return;
      }

      try {
        this.blazeSlider = new window.BlazeSlider(sliderElement, {
          all: {
            enableAutoplay: false,
            enablePagination: false,
            slidesToShow: 1.3,
            slidesToScroll: 1,
            transitionDuration: 300,
            transitionTimingFunction: 'ease-in-out',
            loop: false,
            draggable: true,
            slideGap: '20px',
          },
        });

        this.setupNavigation();
        this.observeForDragSwipe(sliderElement);
        this.syncNavigationState();
      } catch (error) {
        console.error('mini-cart-upsell-carousel: Error initializing BlazeSlider:', error);
      }
    }

    isAtStart() {
      return this.blazeSlider && this.blazeSlider.stateIndex === 0;
    }

    isAtEnd() {
      if (!this.blazeSlider || !this.blazeSlider.states) return false;
      return this.blazeSlider.stateIndex >= this.blazeSlider.states.length - 1;
    }

    syncNavigationState() {
      var atStart = this.isAtStart();
      var atEnd = this.isAtEnd();
      this.querySelectorAll('.js-slide-arrow').forEach(function (button) {
        var direction = button.getAttribute('data-direction');
        var isDisabled = (direction === 'prev' && atStart) || (direction === 'next' && atEnd);
        button.setAttribute('aria-disabled', String(isDisabled));
        button.setAttribute('tabindex', isDisabled ? '-1' : '0');
        if (isDisabled) {
          button.classList.add('swiper-button-disabled');
        } else {
          button.classList.remove('swiper-button-disabled');
        }
      });
    }

    observeForDragSwipe(sliderElement) {
      if (this._classObserver) {
        this._classObserver.disconnect();
      }
      this._classObserver = new MutationObserver(() => {
        this.syncNavigationState();
      });
      this._classObserver.observe(sliderElement, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    setupNavigation() {
      this.querySelectorAll('.js-slide-arrow').forEach((button) => {
        button.addEventListener('click', (event) => this.onArrowClicked(event));
      });
    }

    onArrowClicked(event) {
      if (!this.blazeSlider) return;
      var direction = event.currentTarget.getAttribute('data-direction');
      if (direction === 'prev') {
        this.blazeSlider.prev();
      } else {
        this.blazeSlider.next();
      }
      this.syncNavigationState();
    }
  }
);
